import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';


@Component({
  selector: 'app-collapsible-list',
  templateUrl: './collapsible-list.component.html',
  styleUrls: ['./collapsible-list.component.scss'],
  animations: [
    trigger('animateInOut', [
      state('open', style({
        height: '*'
      })),
      state('collapsed', style({
        height: '0px'
      })),
      transition('* <=> *', animate('500ms ease-in-out')),
    ])
  ]
})
export class CollapsibleListComponent implements OnInit {

  _listItems: Array<String>;
  _listTopItems: Array<String>;

  @Input() listItems;
  @Input() listTopItems;

  toggleState: string = 'collapsed';

  constructor() {}

  ngOnInit() {}

  public get getHighlightedItems() {
    return this.listTopItems;
  }
  public get getCollapsedItems() {
    return this.listItems;
  }

  toggleList() {
    this.toggleState = this.toggleState === 'collapsed' ? 'open' : 'collapsed';
  }

}
